export const order = (a, b) =>
  a.order > b.order ? 1 : b.order > a.order ? -1 : 0;
